// src/Utilities/components/Calculations/MembershipBookingCalculator.js
export const MembershipBookingCalculator = function (bookingInfo) {
  var membershipPrices = {
    Club: 99,
    Plus: 149
  };

  var selectedPackage = null;
  if (bookingInfo && bookingInfo.selectedPackage) {
    selectedPackage = bookingInfo.selectedPackage;
  }

  var basePrice = membershipPrices[selectedPackage] ? membershipPrices[selectedPackage] : 0;

  // future: you can add pro-rated logic or add-ons here if needed
  return {
    originalPrice: basePrice,
    discountedPrice: basePrice
  };
};

export default MembershipBookingCalculator;
